<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-pause-circle`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24 2c12.15 0 22 9.85 22 22s-9.85 22-22 22S2 36.15 2 24 11.85 2 24 2zm0 4C14.059 6 6 14.059 6 24s8.059 18 18 18 18-8.059 18-18S33.941 6 24 6zm-3 8a1 1 0 011 1v18a1 1 0 01-1 1h-2a1 1 0 01-1-1V15a1 1 0 011-1h2zm8 0a1 1 0 011 1v18a1 1 0 01-1 1h-2a1 1 0 01-1-1V15a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconPauseCircle',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
